import site from '../config/site.json';
export function getBasePath() {
  const path = new URL(process.env.PUBLIC_URL || '/', window.location.origin).pathname.replace(/\/$/, '');
  return path;
}
export const assetUrl = path => {
  const base = getBasePath();
  const asset = '/' + path.replace(/^\.?\//, '');
  return base && asset.startsWith(base + '/') ? asset : base + asset;
};
export const canonicalUrl = path => new URL(path.replace(/^\//, ''), site.productionUrl).href;
